import { Link, useLocation } from "react-router-dom";
import { Heart } from "lucide-react";

export const DonateBar = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/donate")) return null;
  return (
    <div
      data-testid="mobile-donate-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-paper/95 backdrop-blur-md border-t border-ink/10 px-4 py-3 flex items-center gap-3"
    >
      <Link
        to="/donate"
        data-testid="mobile-donate-bar-button"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-terra px-6 py-3.5 text-sm font-bold text-paper transition-colors duration-300 hover:bg-terra-dark"
      >
        <Heart size={16} fill="currentColor" />
        Donate now
      </Link>
      <Link
        to="/programs"
        data-testid="mobile-donate-bar-programs"
        className="inline-flex items-center justify-center rounded-full border border-ink/25 px-5 py-3.5 text-sm font-bold text-ink"
      >
        Programs
      </Link>
    </div>
  );
};
